var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-9e7eb39c"), n = n(), _popScopeId(), n); };
var _hoisted_1 = ["id"];
var _hoisted_2 = { class: "w-4 h-4 -mr-2 flex items-center justify-center" };
var _hoisted_3 = {
    key: 0,
    class: "h-4 w-4 rounded-full bg-gray-200"
};
var _hoisted_4 = ["href"];
var _hoisted_5 = {
    key: 1,
    class: "inline-block h-2 w-2 rounded-full bg-gray opacity-30"
};
import { formatToE164, getCountryByPhone, getPhoneMask, isCountryAvailable, phoneStringFormat } from '@common/ui/EInputPhone/utils';
import { countries, userCountry } from '@common/utils/Location';
import EInput from '@common/ui/EInput.vue';
import { computed, nextTick, onMounted, ref } from 'vue';
export default /*#__PURE__*/ _defineComponent(__assign({
    inheritAttrs: false
}, { __name: 'EInputPhone', props: /*#__PURE__*/ _mergeModels({
        name: {},
        theme: {},
        size: {},
        id: {},
        disabled: { type: Boolean, default: false },
        readonly: { type: Boolean, default: false },
        label: {},
        defaultCountryCode: { default: 'ru' },
        inputWithoutValue: { type: Boolean, default: false },
        fitWidth: { type: Boolean }
    }, {
        "modelValue": { required: true, default: '' },
        "modelModifiers": {},
    }), emits: /*#__PURE__*/ _mergeModels(["focus", "blur", "change", "input"], ["update:modelValue"]), setup: function (__props, _a) {
        // const inputRule = z.string().refine(v => !v || isValidPhoneNumberV2(v), 'Номер введен неверно')
        var _this = this;
        var __expose = _a.expose, __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        // todo: нужно разделить модель внутреннюю от внешней,
        //  чтобы можно было наверх отправлять форматированные данные в formatToE164
        var phoneModel = _useModel(__props, "modelValue");
        var eInputRef = ref();
        var country = ref(null);
        var mask = ref('');
        var onBlur = function (e) {
            emit('blur', e);
        };
        var onChange = function (e) {
            emit('change', e);
        };
        var onFocus = function (e) {
            // Устанавливаем курсор в конец строки, чтобы не выделять то что уже есть в поле
            var input = eInputRef.value.inputRef;
            var length = input.value.length;
            // Установка позиции курсора в конец текста
            if (input.setSelectionRange) {
                input.setSelectionRange(length, length);
            }
            else if (input.createTextRange) {
                var range = input.createTextRange();
                range.collapse(true);
                range.moveEnd('character', length);
                range.moveStart('character', length);
                range.select();
            }
            emit('focus', e);
        };
        var setCountry = function (isoCode_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([isoCode_1], __read(args_1), false), void 0, function (isoCode, canUpdateNumber) {
                var countryAvailable, phoneCode;
                if (canUpdateNumber === void 0) { canUpdateNumber = false; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, isCountryAvailable(isoCode)];
                        case 1:
                            countryAvailable = _a.sent();
                            if (isoCode && countryAvailable) {
                                country.value = countries.find(function (c) { return c.iso2 === isoCode; });
                                if (canUpdateNumber) {
                                    phoneCode = Array.isArray(country.value.phoneCode) ? country.value.phoneCode[0] : country.value.phoneCode;
                                    phoneModel.value = phoneStringFormat('' + phoneCode);
                                    mask.value = getPhoneMask(phoneModel.value || '');
                                }
                            }
                            return [2 /*return*/];
                    }
                });
            });
        };
        var input = function (val) {
            var phoneVal = val.replace(/[A-z]/g, '');
            if (!props.inputWithoutValue && (!phoneVal || phoneVal.length > 20))
                return;
            var clearPhone = phoneVal.replace(/\s|\+/g, '');
            var country = getCountryByPhone(clearPhone);
            if (country) {
                setCountry(country.iso2);
            }
            mask.value = getPhoneMask(clearPhone);
            phoneModel.value = phoneVal;
            emit('input', formatToE164(phoneVal));
        };
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // Нужно дать успеть vmask внутри einput инициализироваться
                    return [4 /*yield*/, nextTick()];
                    case 1:
                        // Нужно дать успеть vmask внутри einput инициализироваться
                        _a.sent();
                        try {
                            // Если страну удалось определить и значение пустое, вставляем стандартный код страны
                            if (userCountry && !phoneModel.value) {
                                setCountry(userCountry.iso2, true);
                            }
                            else if (props.defaultCountryCode && !phoneModel.value) {
                                setCountry(props.defaultCountryCode, true);
                            }
                            else if (phoneModel.value) {
                                input(phoneModel.value);
                            }
                        }
                        catch (err) {
                            throw new Error(err);
                        }
                        return [2 /*return*/];
                }
            });
        }); });
        // Плейсхолдер, часть которого заменяется на введенные значения
        // Чтобы при вводе номера не введенная часть маски была видна
        var placeholderRetyped = computed(function () {
            var input = phoneModel.value;
            if (!input) {
                return '';
            }
            var mask = getPhoneMask(input);
            mask = mask ? mask.replaceAll('#', '0') : '';
            return input + mask.slice(input.length);
        });
        var focus = function () {
            var _a;
            (_a = eInputRef.value) === null || _a === void 0 ? void 0 : _a.focus();
        };
        var blur = function () {
            var _a;
            (_a = eInputRef.value) === null || _a === void 0 ? void 0 : _a.blur();
        };
        __expose({
            focus: focus,
            blur: blur,
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", {
                id: _ctx.id,
                class: _normalizeClass([[
                        _ctx.fitWidth ? 'w-fit' : 'w-full'
                    ], "flex items-center"])
            }, [
                _createVNode(EInput, _mergeProps(_ctx.$attrs, {
                    ref_key: "eInputRef",
                    ref: eInputRef,
                    disabled: _ctx.disabled,
                    label: _ctx.label,
                    mask: mask.value,
                    "model-value": phoneModel.value,
                    name: _ctx.name,
                    placeholder: placeholderRetyped.value,
                    readonly: _ctx.readonly,
                    size: _ctx.size,
                    theme: _ctx.theme,
                    class: "",
                    onBlur: onBlur,
                    onChange: onChange,
                    onFocus: onFocus,
                    onInput: input
                }), {
                    prepend: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_2, [
                            (country.value)
                                ? (_openBlock(), _createElementBlock("svg", _hoisted_3, [
                                    _createElementVNode("use", {
                                        href: "/img/icons-bundled/flags.svg#".concat(country.value.iso2)
                                    }, null, 8, _hoisted_4)
                                ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_5))
                        ])
                    ]; }),
                    append: _withCtx(function () { return [
                        _renderSlot(_ctx.$slots, "inputAppend")
                    ]; }),
                    _: 3
                }, 16, ["disabled", "label", "mask", "model-value", "name", "placeholder", "readonly", "size", "theme"])
            ], 10, _hoisted_1));
        };
    } }));
